import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import type CardGatewayDetailViewModel from "viewModels/finance/outgoingPayments/cardGatewayDetailViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatDateTime } from "utils/localizations";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import Section from "views/common/section";
import { emptyValue } from "utils/emptyValue";

const OutgoingPayGatePaymentSection: ViewComponent<CardGatewayDetailViewModel> = observer(({ vm }) => {
  const outgoingPayment = vm.item.outgoingPayment;

  return (
    <Section title={vm.translate("outgoingPaymentTitle")} context={vm.item}>
      <div className="row">
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "paidAmount")}</Form.Label>
          <FakeInput target={outgoingPayment} property="paidAmount" />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "variableSymbol")}</Form.Label>
          <FakeInput target={outgoingPayment} property="variableSymbol" />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "cardNumber")}</Form.Label>
          <FakeInput target={outgoingPayment} property="cardNumber" />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "authorizedAt")}</Form.Label>
          <FakeInput target={outgoingPayment} property="authorizedAt" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "exportedDate")}</Form.Label>
          <FakeInput target={outgoingPayment} property="exportedDate" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group as={Col} sm={12}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "arn")}</Form.Label>
          <FakeInput target={outgoingPayment} property="arn" />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group as={Col}>
          <Form.Label>{vm.translateModelAttribute("payGateSenderBankAccount", "bankAccount")}</Form.Label>
          <FakeInput target={outgoingPayment} property="senderBankAccount" valueFormatter={value => formatBankAccount(value)} />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group as={Col} sm={12}>
          <Form.Label>{vm.translateModelAttribute("outgoingPayGatePayment", "status")}</Form.Label>
          <FakeInput
            target={outgoingPayment}
            property="status"
            valueFormatter={value => (value ? vm.translateOutgoingPayGatePaymentStatus(value) : emptyValue)}
          />
        </Form.Group>
      </div>
    </Section>
  );
});

export default OutgoingPayGatePaymentSection;
